export class ListCatalogDatabasesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<Database>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCatalogDatabasesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
